module.exports = require('./DepBankArticlesAmendmentFilingView');
